module.exports = require('./DepBankArticlesAmendmentFilingView');
